import { useEffect, useMemo, useState } from 'react';
import './App.css';
import { AdminLayout } from './components/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { ReportsPage } from './pages/ReportsPage';
import { SearchPage } from './pages/SearchPage';
import { UploadDetailPage } from './pages/UploadDetailPage';
import { UsersPage } from './pages/UsersPage';
import { logout, subscribeToCurrentUser } from './services/adminService';

export const App = () => {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const [route, setRoute] = useState('search');
  const [selectedCode, setSelectedCode] = useState(null);

  useEffect(() => {
    return subscribeToCurrentUser((currentUser) => {
      setUser(currentUser);
      setAuthReady(true);
    });
  }, []);

  const page = useMemo(() => {
    if (route === 'users') {
      return <UsersPage currentUser={user} />;
    }

    if (route === 'reports') {
      return <ReportsPage currentUser={user} />;
    }

    if (route === 'detail' && selectedCode) {
      return <UploadDetailPage code={selectedCode} onBack={() => setRoute('search')} />;
    }

    return (
      <SearchPage
        onOpenUpload={(code) => {
          setSelectedCode(code);
          setRoute('detail');
        }}
      />
    );
  }, [route, selectedCode, user]);

  if (!authReady) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <span className="spinner-border text-success mb-3" aria-hidden="true" />
          <p className="m-0">Restoring session...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLogin={setUser} />;
  }

  const handleLogout = async () => {
    await logout();
    setUser(null);
  };

  return (
    <div className="start">
      <AdminLayout activeRoute={route} currentUser={user} onLogout={handleLogout} onNavigate={setRoute}>
        {page}
      </AdminLayout>
    </div>
  );
}

